/**
 * route-path — แปลง `AppRoute` เป็น URL
 *
 * 🔴 **ทำไมอยู่ที่นี่ ไม่ใช่ที่แอป** (ย้ายมาจาก `apps/member--web/vite/src/composition/navigation.ts`)
 *    `switch` ข้างล่างเป็น **exhaustive บน `AppRoute`** ซึ่งเป็น union ของ feature นี้
 *    ⇒ ตอนที่มันอยู่ที่แอป: เพิ่ม route ใหม่ใน feature แล้ว **TypeScript ไปฟ้องที่แอป**
 *      คนแก้ feature จึงไม่รู้ว่าตัวเองทำแอปพัง (และถ้ามีเว็บที่ 2 ก็ฟ้อง 2 ที่)
 *    ⇒ อยู่ข้าง `navigation.port.ts` แล้ว **นิยาม route กับ URL ของมัน drift กันไม่ได้
 *      เชิงโครงสร้าง** — ไฟล์ติดกัน แก้พร้อมกัน ฟ้องที่เดียวกัน
 *
 * ℹ️ ตัวที่พาไปจริงคือ `createNavigation()` ของ `@theelite/frontend-shared-web`
 *    ซึ่งรับฟังก์ชันนี้เข้าไปทาง param — **มันไม่รู้จัก `AppRoute` และไม่ควรรู้**
 */
import { LOGIN_PATH, type AppRoute } from '../types/navigation.port.js';

export function pathOf(route: AppRoute): string {
  switch (route.name) {
    case 'home':
      return '/';
    /**
     * ใช้ค่าคงที่จาก port ไม่ hardcode — route table ของแอปใช้ค่าเดียวกันนี้
     * (เพิ่ม route ใหม่แล้วลืม case ที่นี่ = TypeScript ฟ้องทันที เพราะ switch
     *  ต้อง exhaustive ตาม union · นั่นคือสิ่งที่จับข้อนี้ได้ตอนเพิ่ม `login`)
     */
    case 'login':
      return LOGIN_PATH;
    case 'pdpa-consent':
      return `/pdpa-consent?v=${encodeURIComponent(route.version)}`;
    case 'profile-setup':
      return '/profile-setup';
    case 'login-error':
      return `/login-error?reason=${encodeURIComponent(route.reason)}`;
  }
}
